export const STRIPE_RETURN_PARAM = "stripe";
export const STRIPE_RETURN_VALUE = "return";

/** Official Stripe Connect callback. Completes onboarding if needed, then sends the user home. */
export function stripeConnectCallbackUrls() {
  const origin = window.location.origin;
  return {
    returnUrl: `${origin}/stripe/return`,
    refreshUrl: `${origin}/stripe/return?state=refresh`,
  };
}

export function isStripeReturnCallback(
  searchParams: Pick<URLSearchParams, "get">
) {
  return searchParams.get(STRIPE_RETURN_PARAM) === STRIPE_RETURN_VALUE;
}

/** Map `/stripe/return` query params onto the dashboard home URL. */
export function dashboardStripeReturnHref(
  searchParams: Pick<URLSearchParams, "get">
) {
  const next = new URLSearchParams();
  next.set(STRIPE_RETURN_PARAM, STRIPE_RETURN_VALUE);
  const state = searchParams.get("state");
  if (state) next.set("state", state);
  const error = searchParams.get("error");
  if (error) next.set("error", error);
  const description = searchParams.get("error_description");
  if (description) next.set("error_description", description);
  return `/?${next.toString()}`;
}
